import React from 'react'
import styled from 'styled-components';
import background from "../assets/fondo-aer.jpg"

const Frame = styled.div`
    margin-top: 90px;
    height: 150px;
    text-align: center;
    background-color: #09090a;
    position: relative;
    color: #aaa;
    background-image: url(${background});
    background-size: cover;
  `;

const Footer = () => {
  return (
    <Frame>
      <br />
      La <strong>Biblioteca de Aerandir</strong> es propiedad intelectual del Foro de Rol <strong>Aerandir</strong>
      <br />
      <br />
      <a href="https://aerandir.foroes.org">https://aerandir.foroes.org</a>
      <br />
      <br />
      <p>Esta aplicación web fue creada por <a href="https://aerandir.foroes.org/u279">Demian</a></p>
    </Frame>
  );
};

export default Footer